export const mobileSkillsMock = [
{
    mobileSkill: {
      src: "/images/skills/flutter.png",
      alt: "sass",
      width: "60",
      height: "60",
    },
  },
  {
    mobileSkill: {
      src: "/images/skills/dart.png",
      alt: "sass",
      width: "90",
      height: "60",
    },
  },
]